import { SnackBarAlert } from "./Common/SnackBarAlert";
import { Mainpage } from "./Main/Mainpage";

export const AppContainer = () => (
    <>
        <SnackBarAlert />
        <Mainpage />
    </>
);